module.exports = __webpack_public_path__ + "img/users-invite2.44df9bf4.png";